
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

const HOLDER_CLASS = 'tiptap-vuetify-image-upload-area-holder'

@Component
export default class FileSelector extends Vue {
  mounted () {
    const holder = this.$el.querySelector('.' + HOLDER_CLASS)! as HTMLElement
    const input = this.$el.querySelector('#tiptap-vuetify-image-upload-area__input-file')! as HTMLInputElement

    input.addEventListener('change', e => {
      if (e.target instanceof HTMLInputElement) {
        this.filesSelected(e.target.files)
        holder.classList.remove(HOLDER_CLASS + '--dragover')

        e.target.value = ''
      }
    })
    holder.addEventListener('dragover', () => {
      holder.classList.add(HOLDER_CLASS + '--dragover')
      return false
    })

    const dragleaveOrEndHandler = () => {
      holder.classList.remove(HOLDER_CLASS + '--dragover')
      return false
    }

    holder.addEventListener('dragleave', dragleaveOrEndHandler)
    holder.addEventListener('dragend', dragleaveOrEndHandler)
    holder.addEventListener('drop', e => {
      e.preventDefault()
      this.filesSelected(e.dataTransfer!.files)
    })
  }

  filesSelected(files: HTMLInputElement['files']) {
    if(files != null && files.length) {
      [...files].forEach(file => {
        const reader = new FileReader()
        reader.addEventListener('load', readerEvent => {
          this.$emit('select-file', {
            src: readerEvent.target!.result!.toString(),
            alt: file.name
          })
        })
        reader.readAsDataURL(file)
      })
    }
  }
}
